import type { IconProps as Props } from './types';

export const IconChevronRight = ({
  width = '1em',
  height = '1em',
  stroke = 'currentColor',
  title = 'Chevron Right Icon',
  ...rest
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>{title}</title>
    <path
      d="M8 6L12 10L8 14"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
